// Final bootstrap — checks for an existing session and starts the app.
// Imported last by main.js, after every core module and view has registered
// itself, so VIEWS/NAV/etc. are fully populated before startSession() runs.
import { setSession, setCsrfToken, setSessionMode } from './state.js';
import { isAdmin } from './domain-utils.js';
import { showAuth, showForcePasswordChange, showResetConfirm, loadDataFromAPI, startSession, resetToLogin } from './auth.js';

(async () => {
  // A reset link (portal.html?reset=<token>) wins over any existing session:
  // someone following it wants to set a new password, and silently dropping
  // them into an already-signed-in portal would strand the token unused.
  // Stripped from the URL immediately so the token doesn't linger in history,
  // get copy-pasted, or ride along in a Referer header.
  const resetToken = new URLSearchParams(window.location.search).get('reset');
  if (resetToken) {
    history.replaceState(null, '', window.location.pathname);
    showResetConfirm(resetToken);
    return;
  }

  try {
    const res = await fetch('/api/auth/session');
    const data = await res.json();
    if (data.authenticated && data.user) {
      setCsrfToken(data.csrfToken || '');
      const u = data.user;
      const user = {
        id: u.id, firstName: u.firstName, lastName: u.lastName,
        email: u.email, phone: u.phone || '',
        address: u.address || '', city: u.city || '',
        state: u.state || '', zip: u.zip || '',
        roles: u.role === 'both' ? ['parent','admin'] : [u.role],
        adminRole: u.adminRole, mustChangePassword: u.mustChangePassword,
        active: true, card: u.card || null, stripeId: u.stripeId || '',
        // Whether the ask-the-guides assistant is available to this user at
        // all -- full admin, and an API key configured on the server.
        assistant: !!data.assistant
      };
      setSessionMode(isAdmin(user) ? 'admin' : 'parent');
      setSession(user);
      if (user.mustChangePassword) { showForcePasswordChange(); return; }
      try { await loadDataFromAPI(); } catch (e) { console.error('Data load failed:', e); }
      startSession(user);
      return;
    }
    // Deactivated while signed in (spec §1): the sign-in screen says why.
    if (data.accountInactive) { resetToLogin(data.message); return; }
  } catch (e) { console.error('Session check failed:', e); }
  showAuth('login');
})().catch(() => showAuth('login'));
